const filesGroup = document.querySelectorAll('[data-file-group]');

if (filesGroup) {
  filesGroup.forEach(group => {
    const controls = group.querySelectorAll('.c-controls');
    const fileList = group.querySelector('.c-files__list');
    const files = fileList.querySelectorAll('.c-file');
    const selectAllBtns = group.querySelectorAll('.c-controls__btn--select');
    const downloadBtn = group.querySelectorAll('.c-controls__btn--dl');
    let selectedFiles = [];
    const nestedHeader = group.querySelector('.c-files__header--list');

    // Since we have two control elements, both needs to be in sync
    controls.forEach((control, controlI, arr) => {
      const otherControl = Array.from(arr).find((el, eli) => eli !== controlI);
      const toggleEl = control.querySelector('.c-toggle__input');
      toggleEl.addEventListener('click', () => {
        otherControl.querySelector('.c-toggle__input').checked =
          toggleEl.checked;
        fileList.classList.toggle('c-files__list--grid');
        if (nestedHeader) nestedHeader.classList.toggle('hide');
      });
    });

    const updateDownloadBtn = val => {
      downloadBtn.forEach(btn => {
        const countEl = btn.querySelector('.counter');

        countEl.innerHTML = String(val);
      });
    };

    // Handle file selection
    const resetSelection = () => {
      selectedFiles = [];

      files.forEach(file => {
        const fileInput = file.querySelector('.c-file__input');
        fileInput.checked = false;
      });

      downloadBtn.forEach(dlBtn => {
        const btnEl = dlBtn;
        btnEl.classList.add('is-disabled');
      });

      updateDownloadBtn(0);
    };
    selectAllBtns.forEach(btn => {
      btn.addEventListener('click', async () => {
        selectedFiles = Array.from(files).map((file, fileIndex) => fileIndex);

        files.forEach(file => {
          const fileInput = file.querySelector('.c-file__input');
          fileInput.checked = true;
        });

        downloadBtn.forEach(dlBtn => {
          const btnEl = dlBtn;
          btnEl.classList.remove('is-disabled');
        });

        updateDownloadBtn(selectedFiles.length);
      });
    });

    files.forEach((file, fileIndex) => {
      const fileInput = file.querySelector('.c-file__input');

      fileInput.addEventListener('change', e => {
        if (e.target.checked) {
          selectedFiles.push(fileIndex);
        } else {
          selectedFiles = selectedFiles.filter(el => el !== fileIndex);
        }

        downloadBtn.forEach(dlBtn => {
          const btnEl = dlBtn;

          if (selectedFiles.length > 0) {
            btnEl.classList.remove('is-disabled');
          } else {
            btnEl.classList.add('is-disabled');
          }
        });

        updateDownloadBtn(selectedFiles.length);
      });
    });

    // handle File download

    downloadBtn.forEach(btn => {
      const btnEl = btn;

      btn.addEventListener('click', async () => {
        btnEl.classList.add('is-loading');
        const { pid } = btn.dataset;
        const str = `${window.ewg.resturl}/download/${pid}`;
        const formData = new FormData();
        formData.append('files', JSON.stringify(selectedFiles));

        fetch(str, {
          method: 'POST',
          body: formData,
        })
          .then(res => res.json())
          .then(data => {
            const a = document.createElement('a');
            a.href = data;
            document.body.appendChild(a);
            a.click();
            a.remove();
            resetSelection();
            btnEl.classList.remove('is-loading');
          });
      });
    });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/downloads.js